import React, { Component } from 'react';
import './Bio.css';

class Bio extends Component {

    render () {
        return (
            <div className="Bio left-align">
                  <h5>About Me</h5>  
                <p>I am the daughter of two immigrants who taught me to work hard for what you want. When I was a child, my parents made sure to always have the latest full set of Encyclopedias and Dictionaries. If we ever had a question, we were told to "Look it up!" </p>
                
                <p>This is how I learned to not only enjoy asking questions, but also to enjoy the search for answers. 
                
                I have always loved the results of hard work. The knowledge that I can make a decision to complete a goal, do some research on how to do it right, and implement that information to end up with an amazing product that I made all by myself is a life affirming process.</p>
            </div>
        )
    }
}

export default Bio;